import {
  AddressSelector,
  CategorySelector,
  ColumnCountSelector,
  DocumentSelector,
  EInseratReview,
  ImageSelector,
  IssueDateSelector,
  LocationTypeahead,
  WorkloadSelector,
  Payment,
  PlatformSelector,
  PriceComponent,
  Publishing,
  Review,
  StyleSelector,
  VerificationDocumentSelector,
} from './components';
import type { AdComponentType } from '@/pages/Ad/types';

export const StepComponents: Record<string, AdComponentType> = {
  AddressSelector,
  CategorySelector,
  ColumnCountSelector,
  DocumentSelector,
  EInseratReview,
  IssueDateSelector,
  Payment,
  PlatformSelector,
  PriceComponent,
  Publishing,
  Review,
  StyleSelector,
  SingleImageSelector: (props) => <ImageSelector {...props} />,
  MultiImageSelector: (props) => <ImageSelector multiple {...props} />,
  LocationTypeahead,
  WorkloadSelector,
  VerificationDocumentSelector,
};
